import LinkOrAnchor from "./link-or-anchor";
import React from "react";

export default function SignupLink(props) {
  var { children } = props;

  var signupUrl = "/sign-up";
  if (window.env.customLoginLinks) {
    signupUrl = window.env.customLoginLinks.signUp;
  }

  return (
    <LinkOrAnchor to={signupUrl} {...props}>
      {children}
    </LinkOrAnchor>
  );
}
